export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/src/environments/environment.ts